const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const Link = require("../core/view/Link");
const Avatar = require("../core/view/Avatar");
const ArrowIcon = require("../core/view/ArrowIcon");
const InitRenderSwitch = require("../core/view/InitRenderSwitch");
const SharedSiteTopBar = require("./SharedSiteTopBar");
const MenuHover = require("./MenuHover");
const HamburgerMenu = require("./HamburgerMenu");
const {atUser} = require("../core/vault/StateCursors");
const {getUserTopBarName} = require("../../shared/UserDataUtil");
const {getFeatureFlag} = require("../core/util/FeatureFlags");

const {getInfobars, DEFAULT_INFO_BAR_TYPE} = require("../../shared/Infobars");
const {KB_URLS} = require("../../shared/KnowledgeBase");

const Cookie = require("../core/util/Cookie");
const URLMake = require("../../shared/URLMake");

const withRenderSwitch = require("../core/hoc/withRenderSwitch");
const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");

const OpsPage = require("../core/vault/OpsPage");
const OpsUser = require("../core/vault/OpsUser");
const AT = require("../core/vault/ActionTypes");
const OpsCart = require("./vault/OpsCart");

const StoreUtil = require("../../shared/StoreUtil");
const BookstoreUtil = require("../../shared/BookstoreUtil");
const SCU = require("../core/util/SCUUtil");
const ScrollUtil = require("../core/util/ScrollUtil");
const AssetsUtil = require("../core/util/AssetsUtil");
const {
	onClickLoginAsStudent: onClickLoginAsStudentUtil,
} = require("../parent/util/ParentUtil");

// To affect the info bar with a CRO experiment, set
// global.officeInfoBarType. Use "site-maintenance" to display a maintenance
// message, "coupon-info" or "custom" to display a custom alert that can be
// edited in the top bar file. Use null for no info bar. Leave as undefined to
// not affect the default.

// The default info bar is set via this component's getInitialState. (However,
// if we're doing experiments, we probably want to make the bar hidden by
// default so that people don't see it disappear immediately.)

// NOTE: A lot of things in this file are duplicated in the JS and templates in
// src/elev. If you make any changes here, you may need to port them over to
// src/elev as well.

const {FLAGS} = require("../core/util/GlobalFlags");

const topBarInfo = {
	//These pages have no argyle under the top bar
	noBorder: ["office.chalkboard", "parent.studentPrimaryRegistration"],
	//These pages only have the argyle border on desktop sizes (not mobile sizes).
	noMobileBorder: ["office.contact"],
	//Hide top bar completely,
	noTopBar: ["office.classtag"],
};

const styles = require("./styles/TopBar.css");
const revampStyles = require("./styles/TopBarCheckoutRevamp.css");
const {ImitateStudentLink} = require("./ImitateStudentLink");
const {
	isUnregisteredStudent,
} = require("../parent/util/PrimaryRegistrationUtil");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withRenderSwitch(Component);
	Component = withVaultDispatch(Component);

	Component = withVaultUpdate(Component, (props, vaultState) => ({
		isParent: atUser(vaultState)
			.getIn(["model", "roles"], [])
			.includes("parent"),
	}));
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "OfficeTopBar",

		propTypes: {
			noJS: PT.bool,
			page: PT.object.isRequired,
			cart: PT.object.isRequired,
			user: PT.object.isRequired,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
			isFirstRender: PT.bool.isRequired,
			isParent: PT.bool.isRequired,
		},

		shouldComponentUpdate: function(nextProps, nextState) {
			return (
				!SCU.shallowEq(this.state, nextState) ||
				this.props.page !== nextProps.page ||
				this.props.isFirstRender !== nextProps.isFirstRender ||
				OpsCart.getNumItemsWithBundles(this.props.cart) !==
					OpsCart.getNumItemsWithBundles(nextProps.cart) ||
				!_.isEqual(
					_.get(this.props.user, ["model"]),
					_.get(nextProps.user, ["model"])
				)
			);
		},

		getInitialState: function() {
			if (global.window) {
				this.prevScrollY = window.pageYOffset;
			}
			return {
				infoBarType: DEFAULT_INFO_BAR_TYPE,
				overrideInfoBarType: undefined, // set to undefined for no override
				infoBarHover: null, // stores which infobar X button is hovered over
			};
		},

		componentDidMount() {
			const checkInfobar = () => {
				const {
					infoBarType: currentInfoBarType,
					overrideInfoBarType,
				} = this.state;
				let infoBarType = overrideInfoBarType || global.officeInfoBarType;
				// Show IPL migration infobar for all staff at IPL-managed schools
				if (infoBarType === undefined) {
					const user = this.props.user;
					const staffRoles = _.get(user, "model.staffRoles") || {};
					if (
						user &&
						_.get(user, "model.staffForPurchaseID") &&
						staffRoles.isAopsManaged === false
					) {
						infoBarType = "ipl-migration";
					}
				}
				// Check if we should show the primary registration reminder for unregistered students
				if (
					infoBarType === undefined &&
					this.hasUnregisteredStudents() &&
					!this.isOnStudentSetupPage() &&
					this.props.page.name !== "office.main"
				) {
					infoBarType = "primary-registration-reminder";
				}
				// If we are on the student setup page, hide the primary registration reminder
				if (
					infoBarType === undefined &&
					currentInfoBarType === "primary-registration-reminder" &&
					this.isOnStudentSetupPage()
				) {
					infoBarType = "";
				}
				if (infoBarType !== undefined && currentInfoBarType !== infoBarType) {
					this.setState({infoBarType});
				}
			};
			checkInfobar();
			this.pollingInfoBar = setInterval(checkInfobar, 1000);
		},

		componentWillUnmount: function() {
			clearInterval(this.pollingInfoBar);
			document.removeEventListener("scroll", this.debouncedOnScroll);
		},

		vaultEvents: {
			imitateStudentFail: function(studentID) {
				// If the imitation fails, log out the parent and go to the student login page
				const student = this.getStudents().find(s => s.id === studentID);
				this.startLogout(student);
			},
		},

		startLogin: function() {
			this.props.dispatch({
				type: AT.START_OFFICE_LOGIN,
			});
		},

		startLogout: function(loginWith) {
			let logoutPage = URLMake.state.forOffice();
			if (loginWith) {
				// Student, but might not have a username to use with forLoginWith
				logoutPage = URLMake.state.forLogin();
				if (loginWith.username)
					logoutPage = URLMake.state.forLoginWith(loginWith.username);
			}
			this.props.dispatch({
				type: AT.LOGOUT_USER_REQUEST,
				logoutPage,
				/**
				 * Safari inexplicably flips out when a user clicks the Play button
				 * then signs in as another user, citing what looks like a CORS
				 * issue. However, a refresh on the signin page fixes this... so
				 * we're gonna do that.
				 */
				triggerRefresh: true,
			});
		},

		onClickLoginAsStudent: function(student) {
			onClickLoginAsStudentUtil(
				this.props.dispatch,
				student,
				"from-navigation-bar"
			);
		},

		linkPageScroll: function() {
			ScrollUtil.scrollTo("top");
		},

		makeSublink: function(title, linkClass, props = {}) {
			const {keyPrefix, to, action, isExternal, isNewTab} = props;
			const prefix = keyPrefix || "login-link";
			if (props.to) {
				return (
					<Link
						to={to}
						className={linkClass}
						key={prefix + title}
						isExternal={isExternal}
						isNewTab={isNewTab}
					>
						{title}
					</Link>
				);
			} else if (action) {
				return (
					<div className={linkClass} onClick={action} key={prefix + title}>
						{title}
					</div>
				);
			}
		},

		renderOfferingsContents: function() {
			// bookContentForParent produces the correct styling for an Offerings menu without the "Bundle and save!" box.
			const bookContentStyleName = "bookContentForParent";
			const shouldShowOnline =
				OpsUser.hasParentRole(this.props.user) &&
				!OpsUser.hasKey(this.props.user, "admin view");

			const onlineSection = shouldShowOnline ? (
				<div className={styles["offerings-menu-subsection"]}>
					{this.makeSublink("ONLINE", styles["books-nav-sublink"], {
						to: URLMake.forBAOnline(),
					})}
					<div className={styles["books-nav-sublinks"]}>
						<a
							href="/account/add/subscribe"
							className={styles["books-nav-sublink"]}
						>
							Add Student
						</a>
						<a href="/live-classes" className={styles["books-nav-sublink"]}>
							Live Classes
						</a>
					</div>
				</div>
			) : null;

			const contents = (
				<div className={styles["variant-" + bookContentStyleName]}>
					<div className={styles["offerings-dropdown-menu"]}>
						<div className={styles["offerings-dropdown-content"]}>
							{onlineSection}
							<div className={styles["offerings-menu-subsection"]}>
								{this.makeSublink("BOOKS", styles["books-nav-sublink"], {
									to: URLMake.forBookstore(),
								})}
								<div className={styles["books-nav-sublinks"]}>
									{this.renderBookDotVariant()}
									<div className={styles["books-nav-sublinks"]}>
										<a
											href="/books/all-titles"
											className={styles["books-nav-sublink"]}
										>
											All Books
										</a>
										<a
											href="/apparel/shirt-beast"
											className={styles["books-nav-sublink"]}
										>
											T-shirt
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			);
			return this.renderDropdown(styles[bookContentStyleName], contents);
		},

		renderBookContents: function() {
			let bookContentStyleName = "bookContent";
			if (OpsUser.hasTeacherRole(this.props.user))
				bookContentStyleName = "bookContentForTeacher";
			if (OpsUser.hasParentRole(this.props.user))
				bookContentStyleName = "bookContentForParent";

			const contents = (
				<>
					<div className={styles["variant-" + bookContentStyleName]}>
						<div className={styles["books-nav-wrapper"]}>
							{this.renderBookDotVariant()}
							<div className={styles["books-nav-sublinks"]}>
								<a
									href="/books/all-titles"
									className={styles["books-nav-sublink"]}
								>
									All Books
								</a>
								<a
									href="/apparel/shirt-beast"
									className={styles["books-nav-sublink"]}
								>
									T-shirt
								</a>
								<a href="/faq/books" className={styles["books-nav-sublink"]}>
									FAQs
								</a>
							</div>
						</div>
						<Link
							to={URLMake.forEnroll()}
							className={styles["books-nav-bundle-cta"]}
						>
							<img
								src="/assets/wf/images/laptop2x-min.png"
								loading="lazy"
								alt=""
								className={styles["books-nav-bundle-cta-img"]}
							/>
							<div>
								<div>
									Bundle &amp; Save! Combine books with our online curriculum.
								</div>
								<div className={styles["books-nav-bundle-cta-link"]}>
									Explore Now
								</div>
							</div>
						</Link>
					</div>
				</>
			);
			return this.renderDropdown(styles[bookContentStyleName], contents);
		},

		renderBookDotVariant: function() {
			const gradeSets = BookstoreUtil.getAvailableGradeSets()
				.filter(el => el.toString().charAt(1) !== "S")
				.map(g => {
					return (
						<Link
							key={"setlink-" + g}
							to={URLMake.forBookLevel(g)}
							className={styles["books-navlink"]}
						>
							<div className={styles["books-navlink-number-grade-" + g]}>
								{g}
							</div>
							<div>
								Level {g} (Ages {BookstoreUtil.getAgeRangeByGrade(g)})
							</div>
						</Link>
					);
				});
			// Class names are written this way because they are actually webflow
			// class names copied to React.
			return (
				<>
					<div className={styles["books-nav-menu"]}>
						<Link
							to={URLMake.forBookstore()}
							className={styles["books-nav-sublink"]}
						>
							Math Books
						</Link>
						{gradeSets}
						<div className={styles["books-nav-sublink-nonlink"]}>
							Science Books
						</div>
						<Link
							key={"setlink-" + 3}
							to={"/books/science/level-3"}
							className={styles["books-navlink"]}
						>
							<div className={styles["books-navlink-number-grade-" + 3]}>
								{3}
							</div>
							<div>Level {3} (Ages 8-10)</div>
						</Link>
						<Link
							key={"setlink-" + 4}
							to={"/books/science/level-4"}
							className={styles["books-navlink"]}
						>
							<div className={styles["books-navlink-number-grade-" + 4]}>
								{4}
							</div>
							<div>Level {4} (Ages 9-12)</div>
						</Link>

						<div className={styles["books-nav-sublink-nonlink"]}>
							Beyond Level 5
						</div>
						<Link
							to={
								"https://artofproblemsolving.com/store/list/aops-curriculum?utm_source=beastacademy&utm_medium=referral&utm_campaign=beast_os_books_menu"
							}
							isNewTab={true}
							className={styles["books-navlink"]}
						>
							<img
								className={styles["books-navlink-number"]}
								width={32}
								height={32}
								alt={"Art of Problem Solving logo"}
								src={"/assets/images/logos/aops-beyond.svg"}
							/>
							<div>Art of Problem Solving</div>
						</Link>
					</div>
				</>
			);
		},

		// It appears that we no longer use this function now that we've removed the Account menu for parents.
		// Leaving it here for now in case we want it again for something in the future.
		renderOnlineContents: function(isLoggedIn, isParent) {
			let logoutLink,
				subscriptionsLink,
				accountInfoLink,
				parentGuideLink,
				addStudentLink,
				learnMoreLink,
				enrollLink;
			const {user} = this.props;
			const userRoles = OpsUser.getUserRoles(user);
			if (isLoggedIn && userRoles.length) {
				logoutLink = this.makeSublink("Sign Out", styles.onlineLink, {
					action: () => this.startLogout(),
				});
				if (OpsUser.hasParentRole(user) && !OpsUser.isBetaParent(user)) {
					subscriptionsLink = this.makeSublink(
						"Subscriptions",
						styles.onlineLink,
						{
							to: URLMake.forAccount(),
						}
					);
					accountInfoLink = this.makeSublink(
						"Info \u0026 Payments",
						styles.onlineLink,
						{
							to: URLMake.forAccount("information"),
						}
					);
					addStudentLink = this.makeSublink("Add Student", styles.onlineLink, {
						to: URLMake.forAccountSubscribe("add"),
					});
				}
			} else {
				enrollLink = this.makeSublink("Enroll", styles.onlineLink, {
					to: URLMake.forEnroll(),
					type: "enroll",
				});
			}

			if (isParent) {
				learnMoreLink = null;
			} else {
				learnMoreLink = this.makeSublink("Learn More", styles.onlineLink, {
					to: URLMake.forBAOnline(),
					type: "online",
				});
			}

			const content = (
				<>
					{subscriptionsLink}
					{accountInfoLink}
					{parentGuideLink}
					{addStudentLink}
					{learnMoreLink}
					{enrollLink}
					{this.makeSublink("FAQ", styles.onlineLink, {
						to: URLMake.forFAQ("online"),
					})}
					{logoutLink}
				</>
			);
			return this.renderDropdown(styles.onlineContent, content);
		},

		renderEnrollWithLive: function() {
			let bookContentStyleName = "bookContent";
			if (OpsUser.hasTeacherRole(this.props.user))
				bookContentStyleName = "bookContentForTeacher";
			if (OpsUser.hasParentRole(this.props.user))
				bookContentStyleName = "bookContentForParent";

			const content = (
				<>
					<div
						className={
							styles["variant-" + bookContentStyleName] +
							" baReact-enrollWithLive-subnav-item"
						}
					>
						<Link
							to={URLMake.forEnroll()}
							className={styles["books-nav-bundle-cta"]}
						>
							<img
								src="/assets/wf/images/laptop2x-min.png"
								loading="lazy"
								alt="laptop with books"
								// width="500"
								// height="352"
								className={styles["books-nav-bundle-cta-img"]}
							/>
							<div>
								<div
									style={{
										fontSize: 17,
										lineHeight: 1.15,
										fontWeight: 700,
										marginBottom: 8,
									}}
								>
									SELF-PACED PLATFORM
								</div>
								<div>
									Access online math lessons and challenges for Levels 1-5.
								</div>
								<div className={styles["books-nav-bundle-cta-link"]}>
									LEARN MORE
								</div>
							</div>
						</Link>
					</div>

					<div
						className={
							styles["variant-" + bookContentStyleName] +
							" baReact-enrollWithLive-subnav-item"
						}
					>
						<Link
							to={"/live-classes"}
							className={styles["books-nav-bundle-cta"]}
							style={{background: "#61ad00"}}
						>
							<img
								src="/assets/images/vc/students-o.png"
								loading="lazy"
								// width=""
								// height=""
								alt="students collaborating"
								className={styles["books-nav-bundle-cta-img"]}
							/>
							<div>
								<div
									style={{
										fontSize: 17,
										lineHeight: 1.15,
										fontWeight: 700,
										marginBottom: 8,
									}}
								>
									LIVE ONLINE CLASSES
								</div>
								<div>
									Join small, video-based classes with expert instructors for
									Levels 2-5.
								</div>
								<div className={styles["books-nav-bundle-cta-link"]}>
									LEARN MORE
								</div>
							</div>
						</Link>
					</div>

					<div className={"ba-subnav-with_live"}>
						<div className={"ba-subnav-with_live-item"}>
							<img
								src="/assets/wf/images/laptop2x-min.png"
								width="500"
								height="352"
								loading="lazy"
								alt="laptop with books"
							/>
							<div className={"ba-subnav-with_live-h"}>SELF-PACED PLATFORM</div>
							<div className={"ba-subnav-with_live-p"}>
								Access online math lessons and challenges for Levels 1-5.
							</div>
							<a className={"ba-subnav-with_live-btn"} href="/online">
								LEARN MORE
							</a>
						</div>

						<div className={"ba-subnav-with_live-item"}>
							<img
								src="/assets/images/vc/students-dt.png"
								width="522"
								height="354"
								loading="lazy"
								alt="students collaborating"
							/>

							<div className={"ba-subnav-with_live-h"}>LIVE ONLINE CLASSES</div>
							<div className={"ba-subnav-with_live-p"}>
								Join small, video-based classes with expert instructors for
								Levels 2-5.
							</div>
							<a
								className={
									"ba-subnav-with_live-btn ba-subnav-with_live-btn--green"
								}
								href="/live-classes"
							>
								LEARN MORE
							</a>
						</div>
					</div>
				</>
			);

			return this.renderDropdown(
				styles[bookContentStyleName] + " baReact-enrollWithLive-subnav",
				content
			);
		},

		getStudents: function({
			includeInactive = false,
			checkRegistered = false,
		} = {}) {
			const students = _.get(this.props.user, ["model", "students"], []);
			if (includeInactive) return students;

			return students.filter(s => {
				if (checkRegistered) {
					return s.isActive || s.hasRegistered;
				} else {
					return s.isActive || s.inActiveClasses;
				}
			});
		},

		showMessage: function(messageType, student) {
			let extraInfo = null;
			if (student) {
				extraInfo = {
					displayName: student.displayName,
					userID: student.id,
				};
			}
			this.props.dispatch({
				type: AT.SHOW_OFFICE_MESSAGE,
				messageType,
				extraInfo,
			});
		},

		renderPlayContents: function() {
			// This should be all active students (registered and not registered)
			if (!OpsUser.hasParentRole(this.props.user)) {
				// Don't show dropdown of students if teacher account.
				return null;
			}

			const students = this.getStudents();
			if (students.length) {
				const loginLinks = students.map(s => (
					<ImitateStudentLink
						key={"play-" + s.id}
						student={s}
						onClick={() => {
							if (s.hasRegistered) {
								this.onClickLoginAsStudent(s);
							} else {
								window.location.href = URLMake.forParentStudentPrimaryRegistration(
									s.id
								);
							}
						}}
					/>
				));
				const content = (
					<>
						<div className={styles.playItem}>{"Sign in as:"}</div>
						{loginLinks}
					</>
				);
				return this.renderDropdown(styles.playContent, content);
			}
		},

		renderParentReportsContents: function() {
			// This should be all registered students (active and inactive)
			// Only beta parents don't have any registered students, so not
			// showing them anything is the correct behavior
			const registeredStudents = this.getStudents({checkRegistered: true});
			if (registeredStudents.length) {
				const studentLinks = registeredStudents.map(s => {
					const linkTo = s.hasRegistered
						? URLMake.forParentStudent(s.id)
						: OpsPage.getStudentRegistrationPage(s.id);
					return (
						<Link key={"st-" + s.id} className={styles.msLink} to={linkTo}>
							<Avatar
								className={styles.msLinkAvatar}
								avatar={s.avatarData}
								hasRing={true}
								fallbackDisplayName={s.displayName}
							/>
							{s.displayName}
						</Link>
					);
				});

				const content = (
					<>
						<Link
							key={"all"}
							className={styles.msLink}
							to={URLMake.forParent()}
						>
							<Avatar
								className={styles.msLinkAvatar}
								avatar={{}}
								hasRing={true}
								avatarReplacementImgSrc={AssetsUtil.getBeastAvatar("team")}
							/>
							All Students
						</Link>
						{studentLinks}
					</>
				);
				return this.renderDropdown(styles.msContent, content);
			}
		},

		renderResourcesContents: function() {
			const {user} = this.props;
			const isStudent = OpsUser.isStudent(user);
			const resourcesPageLinks = isStudent ? null : (
				<>
					{this.makeSublink("Placement Tests", styles.onlineLink, {
						to: URLMake.forResources("placementtests"),
					})}
					{this.makeSublink("Planning", styles.onlineLink, {
						to: URLMake.forResources("planning"),
					})}
					{this.makeSublink("Printables", styles.onlineLink, {
						to: URLMake.forResources("printables"),
					})}
				</>
			);
			const content = (
				<>
					{resourcesPageLinks}
					{this.makeSublink("Playground", styles.onlineLink, {
						to: URLMake.forPlayground(),
					})}
					{getFeatureFlag("ENABLE_DAILY_PUZZLES")
						? this.makeSublink("Daily Puzzles", styles.onlineLink, {
								to: URLMake.forDailyPuzzles(),
						  })
						: this.makeSublink("All Ten", styles.onlineLink, {
								to: URLMake.forAllTen(),
						  })}
				</>
			);
			return this.renderDropdown(styles.resourcesContent, content);
		},

		renderSchoolContents: function(type) {
			const {user} = this.props;
			const staffRoles = _.get(user, "model.staffRoles") || {};
			const staffClasses = _.get(user, "model.staffClasses") || {};
			const staffSchools = _.get(user, "model.staffSchools") || {};
			const adminSchoolIDs = staffRoles.adminSchoolIDs || [];

			const hasClasses = _.get(staffRoles, "teachClassIDs", []).length > 0;

			let showAllClassesLink, showAllSchoolsLink;
			const purchaseAdminLinks = [];
			const classLinks = [];
			const schoolLinks = [];

			const getLink = (linkType, name, id) => {
				let to;
				if (id && linkType === "School") {
					to =
						type === "accounts"
							? URLMake.forSchoolAccount(id)
							: URLMake.forSchoolReport(id);
				} else if (id && linkType === "Class") {
					to =
						type === "accounts"
							? URLMake.forClassAccount(id)
							: URLMake.forClassReport(id);
				} else if (linkType === "Subscription") {
					to = URLMake.forSchool("accounts", "subscription");
				} else {
					const space = /^All\s/.test(linkType)
						? linkType.substring(4)
						: linkType;
					to = URLMake.forSchool(type, _.toLower(space));
				}

				const linkName = name || linkType;
				return this.makeSublink(linkName, styles.onlineLink, {
					to,
					keyPrefix: type,
				});
			};

			let linkTypes = [];
			if (type === "accounts") {
				linkTypes = ["Subscription", "Staff", "Classes", "Students"];
				if (!staffRoles.isSingleSchool) linkTypes.splice(1, 0, "Schools");
			} else if (type === "reports") {
				linkTypes = ["Classes", "Students"];
				if (!staffRoles.isSingleSchool) linkTypes.unshift("Schools");
			}

			if (staffRoles.adminPurchase) {
				// PURCHASE ADMIN
				_.forEach(linkTypes, linkType =>
					purchaseAdminLinks.push(getLink(linkType))
				);
			} else if (adminSchoolIDs.length > 0) {
				// SCHOOL ADMIN
				// Show all classes link
				showAllClassesLink = true;
				// Show individual school links if < 6 schools, or all schools link
				if (adminSchoolIDs < 6) {
					_.forEach(adminSchoolIDs, sid => {
						if (staffSchools[sid])
							schoolLinks.push(getLink("School", staffSchools[sid], sid));
					});
				} else {
					showAllSchoolsLink = true;
				}
			} else {
				// TEACHER WHO ISN'T AN ADMIN OR PURCHASE ADMIN
				if (_.keys(staffClasses).length > 1) showAllClassesLink = true;
				// Show individual class links if < 6, or links to schools if teaching at multiple
				if (_.keys(staffClasses).length < 6) {
					_.forOwn(staffClasses, (name, cid) => {
						if (staffClasses[cid]) classLinks.push(getLink("Class", name, cid));
					});
				} else {
					const schoolIDs = _.keys(staffSchools);
					if (schoolIDs.length > 1) {
						if (schoolIDs.length < 6) {
							_.forEach(schoolIDs, sid => {
								schoolLinks.push(getLink("School", staffSchools[sid], sid));
							});
						} else {
							showAllSchoolsLink = true;
						}
					}
				}
			}

			const allSchoolsLink = showAllSchoolsLink ? getLink("All Schools") : null;
			const allClassesLink = showAllClassesLink ? getLink("All Classes") : null;

			const contentsStyle =
				classLinks.length > 0 || schoolLinks > 0
					? styles[type + "ContentWide"]
					: styles[type + "Content"];
			const content = (
				<>
					{purchaseAdminLinks}
					{allSchoolsLink}
					{schoolLinks}
					{allClassesLink}
					{classLinks}
				</>
			);
			const shouldRender =
				hasClasses || staffRoles.adminPurchase || adminSchoolIDs.length > 0;
			return shouldRender ? this.renderDropdown(contentsStyle, content) : null;
		},

		renderSupportContents: function() {
			const {user} = this.props;
			const content = (() => {
				if (OpsUser.hasDashboard(user)) {
					const rosteringLink = OpsUser.hasRosteringTab(user)
						? this.makeSublink("Rostering", styles.onlineLink, {
								to: URLMake.forSchoolSupport("rostering"),
						  })
						: null;
					const getStartedLink = OpsUser.isTeacher(user)
						? this.makeSublink("Get Started", styles.onlineLink, {
								to: URLMake.forSchoolSupport("getStarted"),
						  })
						: null;
					return (
						<>
							{getStartedLink}
							{this.makeSublink("Play", styles.onlineLink, {
								to: URLMake.forSchoolSupport("play"),
							})}
							{this.makeSublink("Reports", styles.onlineLink, {
								to: URLMake.forSchoolSupport("reports"),
							})}
							{this.makeSublink("Accounts", styles.onlineLink, {
								to: URLMake.forSchoolSupport("accounts"),
							})}
							{rosteringLink}
							{this.makeSublink("Planning", styles.onlineLink, {
								to: URLMake.forSchoolSupport("planning"),
							})}
							{this.makeSublink("FAQ", styles.onlineLink, {
								to: URLMake.forFAQ("books"),
							})}
							{this.makeSublink("Ask Us!", styles.onlineLink, {
								to: URLMake.forContact(),
							})}
						</>
					);
				} else {
					return (
						<>
							{this.makeSublink("Help Site", styles.onlineLink, {
								to: KB_URLS.MAIN,
								isExternal: true,
								isNewTab: true,
							})}
							{this.makeSublink("Play", styles.onlineLink, {
								to: KB_URLS.NAVIGATING_BAO,
								isExternal: true,
								isNewTab: true,
							})}
							{this.makeSublink("Reports", styles.onlineLink, {
								to: KB_URLS.PARENT_REPORTING_OVERVIEW,
								isExternal: true,
								isNewTab: true,
							})}
							{this.makeSublink("Account", styles.onlineLink, {
								to: KB_URLS.ACCOUNTS_OVERVIEW,
								isExternal: true,
								isNewTab: true,
							})}
							{this.makeSublink("Planning", styles.onlineLink, {
								to: URLMake.forParentSupport("planning"),
								isExternal: true,
							})}
							{this.makeSublink("FAQ", styles.onlineLink, {
								to: URLMake.forFAQ("books"),
							})}
							{this.makeSublink("Ask Us!", styles.onlineLink, {
								to: URLMake.forContact(),
							})}
						</>
					);
				}
			})();
			return this.renderDropdown(styles.supportContent, content);
		},

		renderEducatorsContents: function() {
			const content = (
				<>
					{this.makeSublink("Learn More", styles.onlineLink, {
						to: URLMake.forEducators(),
					})}
					{this.makeSublink("Outcomes", styles.onlineLink, {
						to: URLMake.forOutcomes(),
					})}
				</>
			);
			return this.renderDropdown(styles.educatorsContent, content);
		},

		renderDropdown: function(className, content) {
			return (
				<div className={className}>
					{content}
					<div className={styles.filler} />
				</div>
			);
		},

		renderCartButton: function(containerClass) {
			if (this.props.noJS) {
				return null;
			}

			const numItems = StoreUtil.getItemCountWithBundlesAndSets(
				this.props.cart.items
			);
			const numClass = numItems > 99 ? styles.cSmall : styles.cNormal;

			const numCartItems = (
				<InitRenderSwitch forFirstRender={<span />}>
					<span className={numClass}>{numItems}</span>
				</InitRenderSwitch>
			);

			return (
				<div className={containerClass}>
					<Link to={URLMake.forCheckout()} className={styles.account}>
						<img
							className={styles.cart}
							alt="Cart"
							src={AssetsUtil.getOfficeElement("cart-icon")}
						/>
						<div className={styles.cItems}>
							<div className={styles.cNum}>{numCartItems}</div>
						</div>
					</Link>
				</div>
			);
		},

		//Renders the login/register or my account/sign out button for users as well
		//as the cart
		renderAccountSection: function(noJS, isLoggedIn, containerClass) {
			const {user} = this.props;
			let buttons;
			if (noJS) {
				buttons = []; // for 404 page, where these buttons don't work.
			} else if (isLoggedIn) {
				// Get dropdown links
				const dropdownLinks = [];
				if (OpsUser.hasKey(user, "admin view") && FLAGS.showAdminLinks) {
					dropdownLinks.push(
						<Link
							to="/admin"
							className={styles.loginLink}
							key="admin"
							isExternal={true}
						>
							Admin
						</Link>
					);
				}
				if (OpsUser.hasParentRole(user) && !OpsUser.isBetaParent(user)) {
					dropdownLinks.push(
						<Link
							to={URLMake.forAccount()}
							className={styles.loginLink}
							key="account"
						>
							Account
						</Link>
					);
				} else if (OpsUser.getStaffedPurchaseID(user, "teacher")) {
					dropdownLinks.push(
						<Link
							to={URLMake.forStaffProfile()}
							className={styles.loginLink}
							key="account"
						>
							Profile
						</Link>
					);
				}
				dropdownLinks.push(
					<div
						onClick={() => this.startLogout()}
						className={styles.loginLink}
						key="sign-out"
					>
						Sign Out
					</div>
				);

				// Make correct label
				let avatarEl;

				const shownName = getUserTopBarName(
					user.model,
					getFeatureFlag("ENABLE_UNIFIED_ACCOUNTS")
				);

				if (!_.isEmpty(user.model.avatar)) {
					avatarEl = (
						<Avatar
							avatar={user.model.avatar}
							className={styles.studentAvatar}
							hasRing={true}
						/>
					);
				} else {
					avatarEl = (
						<img
							className={styles.studentAvatar}
							src={AssetsUtil.getDefaultAvatarIcon("parent")}
						/>
					);
				}
				const loginDisplay = (
					<div className={styles.studentLink}>
						<div className={styles.avatarWrapper}>{avatarEl}</div>
						<div className={styles.loginName}>{shownName}</div>
						<div className={styles.loginArrow}>
							<ArrowIcon direction="down" type="sharp" size="fit" />
						</div>
					</div>
				);
				buttons = (
					<MenuHover
						labelClass={styles.accountUser}
						label={loginDisplay}
						showDivider={true}
					>
						<div className={styles.loginContents}>
							<div className={styles.loginContentsDivider} />
							{dropdownLinks}
						</div>
					</MenuHover>
				);
			} else {
				const signInClass = this.props.isFirstRender
					? styles.loginGray
					: styles.login;
				buttons = (
					<div onClick={this.startLogin} className={signInClass} key="sign-in">
						Sign In
					</div>
				);
			}

			return (
				<div className={containerClass}>
					<div className={styles.accountLinks}>{buttons}</div>
					{this.renderClassWalletLogo()}
					{this.renderCartButton(styles.accountContainer)}
				</div>
			);
		},

		renderMainLinks: function(isLoggedIn, user, forMobile) {
			const titleMap = {
				resources: "Resources",
				parent: "Reports",
				reports: "Reports",
				educators: "For Schools",
				accounts: "Accounts",
				support: "Support",
				enroll: "Online",
			};

			const isParent = isLoggedIn && OpsUser.hasParentRole(user);
			const isTeacher = isLoggedIn && OpsUser.isTeacher(user);
			const isStudent = isLoggedIn && OpsUser.isStudent(user);

			const role = (() => {
				if (isParent) return "parent";
				if (isStudent) return "student";
				if (isTeacher) return "teacher";
				return null;
			})();

			const renderMap = {
				offerings: this.renderOfferingsContents(),
				books: this.renderBookContents(),
				enroll: this.renderEnrollWithLive(),
				resources: this.renderResourcesContents(),
				parent: this.renderParentReportsContents(),
				reports: this.renderSchoolContents("reports"),
				accounts: this.renderSchoolContents("accounts"),
				support: this.renderSupportContents(),
				educators: this.renderEducatorsContents(),
			};

			const getToLink = type => URLMake.forTopBarType(type, role);

			const renderLink = type => {
				const isSelected = OpsPage.matchesOfficeBarType(this.props.page, type);
				const linkTo = getToLink(type);
				const clickAction = isSelected ? this.linkPageScroll : null;
				const labelClass = styles.section + " ba-main_nav-item--" + type;
				const contents = renderMap[type];
				// TODO: perhaps adjust reports, accounts, and/or support for small size for teachers as well
				/* NOTE: This is a _massive_ kludge.
				   For some reason, when you change the value of the label from "Enroll" to "ONLINE",
				   the hover menu no longer works. I have *no idea why*, I imagine it may be because of
				   the way the hover menu is implemented - possibly somewhere in the code it is looking for
				   the text, or the class (which is also determined by the label) to trigger the menu on
				   a hover. The idiomatic React way to do this would be to have a state that activates on mouseOver either
				   the link or the menu, and deactivates on mouseLeave, but that is not the way this is set up here.
				   As this would be a target for barbenheimer, this kludge accomplishes changing the label without
				   changing the behavior; but for future reference, tightly coupling the element's behavior to
				   its label is no bueno. -- KAB. */
				let menuHoverLabel = titleMap[type] || _.capitalize(type);
				if (menuHoverLabel === "Enroll") {
					menuHoverLabel = "ONLINE";
				}
				return (
					<MenuHover
						key={"menu-" + type}
						labelClass={labelClass}
						label={menuHoverLabel}
						linkTo={linkTo}
						isExternalLink={type === "support" && role === "parent"}
						clickAction={clickAction}
						isSelected={isSelected}
						showTriangle={true}
					>
						{contents}
					</MenuHover>
				);
			};

			let linkList = ["enroll", "books", "educators"];
			if (isLoggedIn) {
				if (OpsUser.hasDashboard(user)) {
					linkList = ["reports", "accounts", "resources", "support"];
					if (OpsUser.hasKey(user, "admin view")) {
						linkList.push("offerings");
					}
				} else if (isParent) {
					linkList = ["parent", "resources", "support", "offerings"];
				} else if (isStudent) {
					linkList = ["resources"];
				}
			}

			if (forMobile) {
				const menuContents = linkList.map(l => {
					const body = renderMap[l];
					/* Again, this is a kludge. */
					let titleLabel = titleMap[l] || l;
					if (titleLabel.toUpperCase() === "ENROLL") {
						titleLabel = "ONLINE";
					}
					if (body) {
						return {
							title: <div className={styles.menuItem}>{titleLabel}</div>,
							body: renderMap[l],
							subnavType: l,
						};
					} else {
						const toLink = getToLink(l);
						return {
							title: (
								<Link className={styles.menuItem} to={toLink}>
									{titleMap[l] || l}
								</Link>
							),
							subnavType: l,
						};
					}
				});
				return (
					<HamburgerMenu
						className={styles.ham}
						content={menuContents}
						menuClass={styles.hamburgerContent}
						page={this.props.page}
						user={this.props.user}
					/>
				);
			} else {
				return linkList.map(renderLink);
			}
		},

		shouldRenderPrimaryRegistrationReminder: function() {
			return this.state.infoBarType === "primary-registration-reminder";
		},

		hasUnregisteredStudents: function() {
			const {user} = this.props;
			const students = _.get(user, "model.students", []);

			// Check if user is a parent and has students that haven't completed registration
			const isParent = OpsUser.hasRole(user, "parent");
			if (!isParent || students.length === 0) {
				return false;
			}

			// Check if any student hasn't completed registration
			return students.some(isUnregisteredStudent);
		},

		isOnStudentSetupPage: function() {
			const {page} = this.props;
			// Check if current page is the student setup page
			return (
				(page && page.name === "parent.studentPrimaryRegistration") ||
				(typeof window !== "undefined" &&
					window.location.pathname === "/parent/students/setup")
			);
		},

		renderInfobars: function() {
			const {page, user} = this.props;
			const {infoBarType, infoBarHover} = this.state;

			const infobarClassNameMap = {
				yellow: styles.infoBarYellow,
				blue: styles.infoBarBlue,
				"light-blue": styles.infoBarLightBlue,
				"infobar-hide-tinier": styles.infoBarHideTinier,
			};
			const infobars = getInfobars({
				classNameMap: infobarClassNameMap,
				infotype: infoBarType,
			});

			/* The educators page is 11ty so always remove the conference
			banner because it should never render in React. */
			const conferenceBannerIdx = infobars.findIndex(ib => ib.isForEducators);
			if (conferenceBannerIdx >= 0) {
				infobars.splice(conferenceBannerIdx, 1);
			}

			// Honor start/end dates (mirrors the data-start/data-end logic on 11ty)
			const now = new Date();
			const visibleInfobars = infobars.filter(ib => {
				const afterStart = !ib.startDate || new Date(ib.startDate) < now;
				const beforeEnd = !ib.endDate || now < new Date(ib.endDate);
				return afterStart && beforeEnd;
			});

			if (!visibleInfobars.length) {
				return null;
			}

			const shouldRenderInfobars =
				_.includes(["site-maintenance", "ipl-migration"], infoBarType) ||
				(infoBarType === "custom" &&
					!OpsPage.isPageCheckout(page) &&
					!OpsUser.hasTeacherRole(user)) ||
				this.shouldRenderPrimaryRegistrationReminder();
			if (shouldRenderInfobars) {
				return visibleInfobars.map((infobar, i) => {
					const isInfobarHidden =
						Cookie.get(infobar.cookie) === "hide" && !infobar.neverHide;
					if (isInfobarHidden) {
						return null;
					}
					const closeInfoBar = () => {
						infobar.infotype = null;
						this.setState({infoBarHover: null});
						Cookie.set(infobar.cookie, "hide", 30 * 24 * 60 * 60 * 1000);
					};
					let link = null;
					if (infobar.buttonText && infobar.buttonTextMobile) {
						link = (
							<u>
								<Link
									className={styles.infoBarButtonDesktop}
									to={infobar.buttonLink}
									isExternal={infobar.buttonLink.startsWith("http")}
									isNewTab={infobar.buttonNewTab}
								>
									{infobar.buttonText}
								</Link>
								<Link
									className={styles.infoBarButtonMobile}
									to={infobar.buttonLink}
									isExternal={infobar.buttonLink.startsWith("http")}
									isNewTab={infobar.buttonNewTab}
								>
									{infobar.buttonTextMobile}
								</Link>
							</u>
						);
					} else if (infobar.buttonText) {
						link = (
							<u>
								<Link
									to={infobar.buttonLink}
									// ASSUMPTION: internal links would be relative
									isExternal={infobar.buttonLink.startsWith("http")}
									isNewTab={infobar.buttonNewTab}
								>
									{infobar.buttonText}
								</Link>
							</u>
						);
					}
					const xButton = (
						<div
							className={styles.infoBarClose}
							onMouseEnter={() => {
								this.setState({infoBarHover: infobar.cookie});
							}}
							onMouseLeave={() => {
								this.setState({infoBarHover: null});
							}}
						>
							<div
								className={
									infoBarHover === infobar.cookie
										? styles.infoBarCloseHover
										: styles.infoBarCloseImage
								}
								onClick={closeInfoBar}
							/>
						</div>
					);
					return (
						<div
							className={
								(infobar.classes || []).join(" ") +
								" ba-infobar--" +
								infoBarType
							}
							key={`infobar${i}`}
						>
							<div
								className={styles.infoBarText}
								// NOTE: dangerouslySetInnerHTML to support children elements
								dangerouslySetInnerHTML={{__html: infobar.text}}
							/>
							{link}
							{xButton}
						</div>
					);
				});
			}
			// deprecated, but leaving here for reference
			/*
				const detailAction = () => this.showMessage("couponInfo");
				const closeAction = () => this.setState({infoBarType: null});
				return (
					<div className={infoBarStyle}>
						<div className={styles.infoBarText}>
							<span className={styles.infoBarLongText}>
								{"Use code "}
								<b>{"FlattenTheCurve"}</b>
								<span className={styles.infoBarHideTinier}>{" during"}</span>
								<br className={styles.infoBreak} />
								<span className={styles.infoBarHideTinier}>{" checkout"}</span>
								{" for $15 off a new"}
								<span className={styles.infoBarHide}>
									{" Monthly or Yearly "}
								</span>
								{" subscription."}
							</span>
						</div>
						<div className={styles.infoDetailButton} onClick={detailAction}>
							<span className={styles.detailStandard}>Details</span>
							<span className={styles.detailMobile}>i</span>
						</div>
						<div className={styles.infoEnrollButton}>
							<Link className={styles.detailStandard} to={URLMake.forEnroll()}>
								Enroll
							</Link>
						</div>
						<div className={styles.barClose} onClick={closeAction}>
							<div className={styles.closeIcon} />
						</div>
					</div>
				);
				*/
		},

		renderRevampHeader: function(infoBar, brandBorderStyle) {
			const {page} = this.props;

			const continueShoppingLink =
				page.step === "cart" ? (
					<Link
						to={URLMake.forOffice()}
						className={revampStyles.continueShoppingContainer}
					>
						<div className={revampStyles.continueShoppingArrowContainer}>
							<ArrowIcon
								direction="left"
								size="fit"
								colorName="mainBlue"
								tail="true"
							/>
						</div>
						<div className={revampStyles.continueShoppingLink}>
							Back to Shopping
						</div>
					</Link>
				) : null;

			const breadcrumb =
				page.step === "cart" || page.step === "confirm"
					? null
					: this.renderRevampBreadcrumb();

			const backToCartLink =
				page.step === "cart" || page.step === "confirm" ? null : (
					<Link
						to={URLMake.forCheckoutStep("cart")}
						className={revampStyles.backToCartContainer}
					>
						<img
							className={revampStyles.cartImage}
							alt="Cart Icon"
							src={AssetsUtil.getOfficeElement("cart-icon")}
						/>
						<div className={revampStyles.backToCartLink}>Back to Cart</div>
					</Link>
				);

			return (
				<React.Fragment>
					<div className={revampStyles.revampHeader}>
						<div className={revampStyles.headerContainer}>
							<Link
								to={URLMake.forOffice()}
								className={revampStyles.logoContainer}
							>
								<img
									className={revampStyles.logoImage}
									alt="Beast Academy Logo"
									src={AssetsUtil.getLogo("aops-ba")}
								/>
							</Link>
							{continueShoppingLink}
							{breadcrumb}
							{backToCartLink}
						</div>
					</div>
					<div className={brandBorderStyle} />
					{infoBar}
				</React.Fragment>
			);
		},

		renderRevampBreadcrumb: function() {
			const {cart, user, page} = this.props;
			const steps = OpsCart.getAllCheckoutSteps(cart);
			const availableSteps = OpsCart.getAvailableCheckoutSteps(cart, user);
			const stepLabels = steps.map(s => (s === "paypalinfo" ? "info" : s));

			const onChangeStep = newStep => {
				if (newStep !== page.step) {
					this.props.dispatch({
						type: AT.SET_PAGE,
						pageState: URLMake.state.forCheckoutStep(newStep),
						addToHistory: true,
					});
				}
			};

			const sectionButtons = steps.map((s, i) => {
				if (s === "cart") return;
				let modeClass = revampStyles.availableStep;
				let onClick = () => onChangeStep(s);
				if (!_.includes(availableSteps, s)) {
					modeClass = revampStyles.disabledStep;
					onClick = null;
				} else if (s === page.step) {
					modeClass = revampStyles.selectedStep;
				}

				return (
					<div
						className={
							revampStyles.breadCrumbStepContainer +
							(modeClass ? " " + modeClass : "")
						}
						key={"step-" + s}
						onClick={onClick}
					>
						<div className={revampStyles.breadcrumbIconContainer}>
							<div className={revampStyles.stepNumberText}>{i}</div>
						</div>
						<div className={revampStyles.linkText}>{stepLabels[i]}</div>
					</div>
				);
			});

			return (
				<div className={revampStyles.breadcrumbContainer}>{sectionButtons}</div>
			);
		},

		renderClassWalletLogo: function() {
			const src = AssetsUtil.getLogo("cw-logo", {extension: "png"});
			const {cart} = this.props;
			return cart.isClassWalletFlow ? (
				<div className={styles.classWalletIndicator}>
					<img className={styles.classWalletImage} src={src} />
				</div>
			) : null;
		},

		render: function() {
			const {user, noJS, page} = this.props;
			const pageName = page && page.name;
			if (_.includes(topBarInfo.noTopBar, pageName)) {
				return null;
			}
			const isLoggedIn = OpsUser.isLoggedIn(user);
			const students = this.getStudents();
			const isCheckout = OpsPage.isPageCheckout(page);
			let linkTo = URLMake.forHome();
			if (!OpsUser.hasAoPSRole(user) && isLoggedIn && students.length) {
				//No link if they have students in the menu
				linkTo = null;
			}

			let mainClass = styles.main;
			if (process.env.NODE_ENV !== "production" && FLAGS.navBarColorChanges) {
				mainClass += " " + styles.debug;
			}
			const infobars = this.renderInfobars();
			if (infobars) {
				mainClass += " " + styles.hasInfoBar;
			}
			if (_.size(infobars) === 2) {
				mainClass += " " + styles.hasTwoInfoBars;
			}
			if (isCheckout) {
				mainClass += " " + styles.noSharedSiteTopBar;
			}

			let brandBorderStyle = styles.brandBorder;
			if (_.includes(topBarInfo.noBorder, pageName)) {
				brandBorderStyle += " " + styles.borderHidden;
			} else if (_.includes(topBarInfo.noMobileBorder, pageName)) {
				brandBorderStyle += " " + styles.borderHiddenOnMobile;
			}

			return (
				<div className={styles.mainOuter}>
					<div className={mainClass}>
						{isCheckout ? null : <SharedSiteTopBar />}
						<div className={styles.topContainer}>
							<div className={styles.home}>
								<div className={styles.sectionsB}>
									{this.renderMainLinks(isLoggedIn, user, true)}
								</div>
								<Link to={URLMake.forOffice()} className={styles.logoContainer}>
									<img
										className={styles.logoImageA}
										alt="Beast Academy"
										src={AssetsUtil.getLogo("aops-ba")}
									/>
									<img
										className={styles.logoImageB}
										alt="Beast Academy"
										src={AssetsUtil.getLogo("aops-ba-cubeless")}
									/>
								</Link>
							</div>
							<div className={styles.links}>
								{this.renderAccountSection(noJS, isLoggedIn, styles.accounts)}
								<div className={styles.sectionsA}>
									{this.renderMainLinks(isLoggedIn, user)}
									<MenuHover
										key={"menu-play"}
										labelClass={styles.play}
										labelOpenClass={styles.playOpen}
										isRedArrow={true}
										linkTo={linkTo}
										label={"Play"}
										showTriangle={true}
									>
										{this.renderPlayContents()}
									</MenuHover>
									{this.renderCartButton(styles.smallerOnlyCart)}
								</div>
							</div>
						</div>
						<div className={brandBorderStyle} />
						{infobars}
					</div>
				</div>
			);
		},
	})
);
